/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S5_Li1Inputs */

const tr_servis_s5_li1 = /** @type {(inputs: Servis_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik bedelinin ödenmemesi (7 günlük gecikme sonrası ihtarname ile)`)
};

const en_servis_s5_li1 = /** @type {(inputs: Servis_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-payment of the subscription fee (after a 7 day delay, by formal notice)`)
};

const de_servis_s5_li1 = /** @type {(inputs: Servis_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichtzahlung der Abonnementgebühr (nach 7 Tagen Verzug, mit Mahnung)`)
};

const ru_servis_s5_li1 = /** @type {(inputs: Servis_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неоплата стоимости подписки (после 7 дней просрочки, с направлением уведомления)`)
};

/**
* | output |
* | --- |
* | "Non-payment of the subscription fee (after a 7 day delay, by formal notice)" |
*
* @param {Servis_S5_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s5_li1 = /** @type {((inputs?: Servis_S5_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S5_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s5_li1(inputs)
	if (locale === "de") return de_servis_s5_li1(inputs)
	if (locale === "ru") return ru_servis_s5_li1(inputs)
	return tr_servis_s5_li1(inputs)
});